import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_icon = _resolveComponent("t-icon")!
  const _component_t_ranger = _resolveComponent("t-ranger")!
  const _component_t_action_sheet = _resolveComponent("t-action-sheet")!

  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
    class: _ctx.getClasses.wrap,
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onTap && _ctx.onTap(...args)))
  }), [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClasses.body)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClasses.content)
        }, [
          (_ctx.getIsShowPlaceholder)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(_ctx.getClasses.placeholder)
              }, _toDisplayString(_ctx.placeholder), 3))
            : _createCommentVNode("", true),
          (_ctx.getIsShowTitle && _ctx.getTitle)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(_ctx.getClasses.title)
              }, _toDisplayString(_ctx.getTitle), 3))
            : _createCommentVNode("", true),
          (_ctx.getIsShowLabel && _ctx.getLabel)
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: _normalizeClass(_ctx.getClasses.label)
              }, _toDisplayString(_ctx.getLabel), 3))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.hasArrow)
          ? (_openBlock(), _createBlock(_component_t_icon, {
              key: 0,
              class: _normalizeClass(_ctx.getClasses.arrowIcon),
              size: "xsmall",
              "icon-name": _ctx.iconName,
              theme: _ctx.disabled ? 'disabled' : 'default'
            }, null, 8, ["class", "icon-name", "theme"]))
          : _createCommentVNode("", true)
      ], 2)
    ], true),
    (_ctx.hasBottomBorder)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.getClasses.border)
        }, null, 2))
      : _createCommentVNode("", true),
    _createVNode(_component_t_action_sheet, {
      modelValue: _ctx.isActionSheetShow,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isActionSheetShow) = $event)),
      "cancel-title": _ctx.cancelTitle,
      "confirm-title": _ctx.confirmTitle,
      onClose: _ctx.onCancel,
      onCancel: _ctx.onCancel,
      onConfirm: _ctx.onConfirm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_t_ranger, {
          modelValue: _ctx.modelValueBySelected,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValueBySelected) = $event)),
          options: _ctx.options
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["modelValue", "cancel-title", "confirm-title", "onClose", "onCancel", "onConfirm"])
  ], 16))
}